import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const splideFvElements = document.getElementsByClassName('splide__fv splide');
const splideBusi = document.getElementsByClassName('splide__busi splide');
const splideWorks = document.getElementsByClassName('splide__works splide');
const splideNews = document.getElementsByClassName('splide__news splide');

if (splideFvElements.length) {
  let fvSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideFvElements.length; i++) {
    let fvSlide = new Splide(splideFvElements[i], {
      // ここにオプションを設定
      type: "fade", // ループさせる
      rewind: true,
      pauseOnHover: false,
      autoplay: true,
      arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      perPage: 1, // 表示するスライドの枚数
      interval: 8000,
    }).mount();

    fvSlides.push(fvSlide);
  }

}

if (splideBusi.length) {
  let busiSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideBusi.length; i++) {
    let busiSlide = new Splide(splideBusi[i], {
      // ここにオプションを設定
      arrows: false, // 矢印ボタンを非表示
      pagination: false, // ページネーションを非表示
      perPage: 3, // 表示するスライドの枚数
    }).mount();
    // var bar = splideBusi[i].parentElement.querySelector('.my-slider-progress-bar');
    // busiSlide.on('move', () => {
    //   let end = busiSlide.Components.Controller.getEnd() + 1;
    //   let rate = Math.min((busiSlide.index + 1) / end, 1);
    //   bar.style.width = String(100 * rate) + '%';
    // });

    busiSlides.push(busiSlide);
  }

}

if (splideWorks.length) {
  let worksSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideWorks.length; i++) {
    let worksSlide = new Splide(splideWorks[i], {
      // ここにオプションを設定
      arrows: false, // 矢印ボタンを非表示
      type: 'loop',
      pagination: false, // ページネーションを非表示
      perPage: 1, // 表示するスライドの枚数
      padding: 'calc(50% - 361px)',
      gap: '40px'
    }).mount();
    // var bar = splideWorks[i].parentElement.querySelector('.my-slider-progress-bar');
    // worksSlide.on('move', () => {
    //   let end = worksSlide.Components.Controller.getEnd() + 1;
    //   let rate = Math.min((worksSlide.index + 1) / end, 1);
    //   bar.style.width = String(100 * rate) + '%';
    // });

    worksSlides.push(worksSlide);
  }

}

if (splideNews.length) {
  let newsSlides = [];

  // FVスライダーの初期化
  for (let i = 0; i < splideNews.length; i++) {
    let newsSlide = new Splide(splideNews[i], {
      // ここにオプションを設定
      arrows: false, // 矢印ボタンを非表示
      type: 'loop',
      pagination: true, // ページネーションを非表示
      perPage: 1, // 表示するスライドの枚数
      padding: 'calc(50% - 230.5px)',
      gap: '32px',
      breakpoints: {
        1025: {
          padding: 'calc(50% - 139.5px)',
          gap: '12px',
        }
      }
    }).mount();
    // var bar = splideNews[i].parentElement.querySelector('.my-slider-progress-bar');
    // newsSlide.on('move', () => {
    //   let end = newsSlide.Components.Controller.getEnd() + 1;
    //   let rate = Math.min((newsSlide.index + 1) / end, 1);
    //   bar.style.width = String(100 * rate) + '%';
    // });

    newsSlides.push(newsSlide);
  }

}
